import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'me-popover-column',
  styleUrl: 'me-popover-column.scss',
  shadow: false,
})
export class MePopoverColumn {

  render() {
    return (
      <Host class="me-popover-column">
        <slot></slot>
      </Host>
    );
  }

}
